import React  from 'react';
import { PredictiveInput } from '@app/src/common/PredictiveInput';

export const renderPredictive = ({
  input,
  dataList,
  handleChange,
  handleBlur,
  meta: {touched, error},
  handleClickClose,
  defaultUbigeo,
  disabled,
  isLoading,
  onDemand
}) => {
  const handleBlurProp = () => {
    input.onBlur && input.onBlur();
    handleBlur && handleBlur();
  }

  const onChangeProp = (e) => {
    if (defaultUbigeo && defaultUbigeo.district) {
      input.onChange && input.onChange(e);
    }
  }

  return(
    <PredictiveInput
      input={input}
      dataList={dataList}
      defaultUbigeo={defaultUbigeo}
      handleChange={handleChange}
      handleBlurInput={handleBlurProp}
      handleChangeInput={onChangeProp}
      error={touched && error}
      handleClickClose={handleClickClose}
      disabled={disabled}
      isLoading={isLoading}
      onDemand={onDemand}
    />
)};
